import type { Character } from '@/types';

export const characters: Character[] = [
  {
    id: 'yu-nu',
    name: '玉女',
    actor: '林清鸢',
    movieId: 'yu-nv-xin-jing-2',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20period%20film%20character%20portrait%20of%20a%20composed%20young%20female%20swordswoman%20in%20flowing%20jade%20green%20robes%20with%20subtle%20hairpin%2C%20calm%20determined%20gaze%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20even%20soft%20lighting%2C%20high%20detail%2C%20minimal%20composition&width=400&height=400&seq=char-yunu&orientation=squarish',
    roleTag: '女主角',
    background:
      '《玉女心经》一脉最后的传人，自幼在深山师门中修行，心经残卷是她唯一的身世线索。师门覆灭后，她独自守着一份未竟的承诺闭关十年，直到信物重现江湖才被迫走出山林。',
    personality:
      '外冷内韧，言语不多却心思极细。她习惯把情绪收进剑鞘里，遇事先看人再看理，一旦认定了是非，就再不肯退让半步。看似无欲无求的修行，其实藏着一份极重的执念。',
    plotPoints: [
      '在竹林旧居重启《玉女心经》残卷，发现师门覆灭的记载被人刻意涂改。',
      '与沈司白在山道初遇时彼此试探，因一枚信物结下同行之约。',
      '玄阴一脉围山之夜被迫全力出剑，第一次暴露心经真正的运功法门。',
    ],
  },
  {
    id: 'shen-si-bai',
    name: '沈司白',
    actor: '张启伦',
    movieId: 'yu-nv-xin-jing-2',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20period%20film%20character%20portrait%20of%20a%20stoic%20young%20male%20swordsman%20in%20dark%20green%20cross%20collared%20robes%20with%20a%20plain%20sword%20hilt%20visible%2C%20quiet%20watchful%20expression%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20even%20soft%20lighting%2C%20high%20detail%2C%20minimal%20composition&width=400&height=400&seq=char-shensibai&orientation=squarish',
    roleTag: '男主角',
    background:
      '行走江湖的独行侠客，剑法干净利落，行踪飘忽。他受人之托追寻《玉女心经》的下落，起初只把玉女当作任务中的一环，却在一次次生死同行里，慢慢动摇了自己立下的规矩。',
    personality:
      '冷静克制，嘴上不饶人，行动上却总把别人护在身后。他信奉「先做后说」，习惯用沉默消化情绪。表面理智清醒，内里其实比谁都重情，也因此更怕辜负。',
    plotPoints: [
      '在古镇酒肆因一桩误会与玉女交手，识破玄阴门人的伪装。',
      '于断桥伏击战中为护玉女负伤，第一次说出自己受谁所托。',
      '得知真相后选择违背委托，陪同玉女直入玄阴总坛。',
    ],
  },
  {
    id: 'xuan-yin-lao-zu',
    name: '玄阴老祖',
    actor: '陆无咎',
    movieId: 'yu-nv-xin-jing-2',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20period%20film%20character%20portrait%20of%20an%20imposing%20elderly%20martial%20arts%20master%20with%20long%20grey%20hair%2C%20deep%20green%20black%20robes%20with%20subtle%20dark%20patterns%2C%20severe%20piercing%20gaze%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20dramatic%20soft%20lighting%2C%20high%20detail&width=400&height=400&seq=char-xuanyin&orientation=squarish',
    roleTag: '主要反派',
    background:
      '玄阴一脉的掌权者，出身与《玉女心经》师门同源，却因一场旧怨走向对立。他花了数十年布局，只为拿到心经中的完整法门，以证明当年被逐出师门的自己才是对的。',
    personality:
      '深谋远虑，喜怒不形于色。他讲话温和，手段却极冷。对他而言，人不过是棋盘上的落子，唯一的执念是「证明自己」——这份执念既成就了他，也困住了他。',
    plotPoints: [
      '暗中收买江湖线人，抢先一步掌握玉女的行踪。',
      '在藏书阁现身，道出师门覆灭背后被掩盖的另一半真相。',
      '最终对决中强行催动残缺心法，反被自身所困。',
    ],
  },
  {
    id: 'xiao-man',
    name: '小蛮',
    actor: '苏晓棠',
    movieId: 'yu-nv-xin-jing-2',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20period%20film%20character%20portrait%20of%20a%20lively%20young%20female%20servant%20in%20beige%20and%20green%20simple%20robes%20with%20two%20hair%20buns%2C%20bright%20cheerful%20expression%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20even%20soft%20lighting%2C%20high%20detail%2C%20minimal%20composition&width=400&height=400&seq=char-xiaoman&orientation=squarish',
    roleTag: '女配角',
    background:
      '玉女在归途上救下的小侍女，机灵话多，熟知坊间消息。她看似只是个跟班，却总能在关键时刻用最简单的话点醒犹豫的玉女，是整条线里最有人间烟火气的角色。',
    personality:
      '活泼直率，心里藏不住事，认准了谁就掏心掏肺地护着。她胆小却讲义气，常常嘴上喊怕，脚下却不后退。',
    plotPoints: [
      '在集市上意外截获玄阴门人传递的密信，成为破局关键。',
      '护送受伤的玉女躲进废弃戏台，用唱段掩护藏身。',
    ],
  },
  {
    id: 'liu-wu-hen',
    name: '柳无痕',
    actor: '周慕云',
    movieId: 'yu-nv-xin-jing-2',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20period%20film%20character%20portrait%20of%20a%20scholarly%20middle%20aged%20man%20in%20cream%20colored%20robes%20holding%20a%20folded%20fan%2C%20thoughtful%20and%20guarded%20expression%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20even%20soft%20lighting%2C%20high%20detail%2C%20minimal%20composition&width=400&height=400&seq=char-liuwuhen&orientation=squarish',
    roleTag: '配角',
    background:
      '自称江湖说书人的中年文士，谈吐风雅，实则与师门旧事牵连甚深。他既是消息的传递者，也是真相的共谋者，每一次现身都让线索更清晰，也更沉重。',
    personality:
      '圆融世故，善于察言观色，说话总留三分。他并不坏，只是太懂得在乱世里保全自己，直到最后才肯把心里那点愧意说出口。',
    plotPoints: [
      '在茶馆一句无心的评书，意外点破心经残卷的来处。',
      '将珍藏多年的师门名录交给玉女，揭开覆灭真相的一角。',
    ],
  },
  {
    id: 'su-qing-yuan',
    name: '苏清鸢',
    actor: '郑婉',
    movieId: 'yu-nv-xin-jing-2',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20period%20film%20character%20portrait%20of%20an%20elegant%20young%20woman%20in%20deep%20green%20embroidered%20robes%20with%20a%20jade%20hairpin%2C%20composed%20melancholic%20expression%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20even%20soft%20lighting%2C%20high%20detail%2C%20minimal%20composition&width=400&height=400&seq=char-suqingyuan&orientation=squarish',
    roleTag: '配角',
    background:
      '药庐主人的女儿，精通草药与疗伤之术。她与玄阴一脉有着说不清的旧缘，在帮助玉女疗伤的过程中，也逐渐直面自己一直被回避的过往。',
    personality:
      '温柔而坚定，习惯先照顾别人再考虑自己。她话不多，却总能在最恰当的时候给出最实在的帮助。',
    plotPoints: [
      '在药庐为沈司白解毒，道出玄阴毒功的破解之法。',
      '主动带路前往玄阴总坛的隐秘入口，完成自我和解。',
    ],
  },
  {
    id: 'yu-nu-young',
    name: '少年玉女',
    actor: '林清鸢',
    movieId: 'yu-nv-xin-jing',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20period%20film%20character%20portrait%20of%20an%20innocent%20teenage%20girl%20in%20simple%20white%20training%20robes%20holding%20a%20short%20wooden%20sword%2C%20resolute%20yet%20vulnerable%20expression%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20soft%20lighting%2C%20high%20detail&width=400&height=400&seq=char-yunuyoung&orientation=squarish',
    roleTag: '女主角',
    background:
      '《玉女心经》前作中的少女时期，师门尚在，她只是个爱在梅花树下练剑的普通弟子。一场大火改写了她的命运，也让这个名字从此与心经紧紧绑在一起。',
    personality:
      '天真里带着一股不服输的倔劲。她信赖师门，也害怕失去，正因为这份珍惜，才在后来学会了一个人扛下所有。',
    plotPoints: [
      '在师门覆灭之夜被师父托付《玉女心经》，含泪立誓守护传承。',
      '与书生沈砚于乱世相护，第一次懂得何谓「选择」。',
    ],
  },
  {
    id: 'shen-yan',
    name: '沈砚',
    actor: '沈砚',
    movieId: 'yu-nv-xin-jing',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20period%20film%20character%20portrait%20of%20a%20gentle%20young%20scholar%20in%20plain%20cream%20robes%20holding%20a%20scroll%2C%20kind%20sincere%20expression%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20even%20soft%20lighting%2C%20high%20detail%2C%20minimal%20composition&width=400&height=400&seq=char-shenyan&orientation=squarish',
    roleTag: '男主角',
    background:
      '流落乱世的寒门书生，因一卷旧书与少年玉女相识。他手无缚鸡之力，却总在危险来临时挡在她身前，用最笨拙的方式诠释着守护。',
    personality:
      '温和谦逊，骨子里却极有原则。他相信道理胜过刀剑，也因此成为玉女心中「另一种可能」的象征。',
    plotPoints: [
      '在破庙中为受伤的玉女挡下追兵，结下生死之谊。',
      '以旧书残页帮她辨认心经中的古文字，推动关键线索。',
    ],
  },
  {
    id: 'gu-chang-ge',
    name: '顾长歌',
    actor: '江彻',
    movieId: 'jian-ying-jiang-hu',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20martial%20arts%20film%20character%20portrait%20of%20a%20weathered%20retired%20swordsman%20in%20dark%20green%20travel%20robes%20with%20a%20scar%20and%20old%20sword%2C%20grave%20resolute%20expression%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20dramatic%20soft%20lighting%2C%20high%20detail&width=400&height=400&seq=char-guchangge&orientation=squarish',
    roleTag: '男主角',
    background:
      '退隐十年的成名剑客，因一纸旧约被迫重回江湖。昔日的兄弟已成一派之主，一桩灭门旧案成为他归来的理由，也成为他挥之不去的枷锁。',
    personality:
      '寡言、念旧，重诺重于性命。他不擅长解释，也不屑于解释，只在拔剑的那一刻用行动表明立场。',
    plotPoints: [
      '在旧宅取回封存十年的佩剑，决定赴约。',
      '与昔日兄弟于雨中对峙，最终选择守住公道。',
    ],
  },
  {
    id: 'wen-wan',
    name: '温婉',
    actor: '柳如烟',
    movieId: 'jian-ying-jiang-hu',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20martial%20arts%20film%20character%20portrait%20of%20a%20poised%20young%20woman%20in%20cream%20and%20green%20robes%20holding%20a%20folded%20letter%2C%20steady%20compassionate%20expression%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20soft%20even%20lighting%2C%20high%20detail&width=400&height=400&seq=char-wenwan&orientation=squarish',
    roleTag: '女主角',
    background:
      '镖局遗孤，自幼在江湖边缘长大，熟知各派恩怨。她是那桩旧案唯一的目击者，也是顾长歌归来路上最重要的同行者。',
    personality:
      '冷静通透，善于权衡，却始终守着自己的底线。她看似理性，实则比谁都渴望一个公道。',
    plotPoints: [
      '将保存多年的证物交给顾长歌，推动真相浮出水面。',
      '在关键时刻出手掩护，改变了对决的走向。',
    ],
  },
  {
    id: 'lin-zhao-zhao',
    name: '林昭昭',
    actor: '花间',
    movieId: 'hua-jian-ling',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20ancient%20mystery%20drama%20character%20portrait%20of%20a%20sharp%20young%20female%20constable%20in%20deep%20green%20hanfu%20holding%20a%20sealed%20letter%2C%20keen%20observant%20expression%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20soft%20even%20lighting%2C%20high%20detail&width=400&height=400&seq=char-linzhaozhao&orientation=squarish',
    roleTag: '女主角',
    background:
      '城中唯一的女捕快，因破案敏锐而被破格录用。一封无名的「花间令」将她卷入十年前的旧案，也逼她正视自己一直回避的身世。',
    personality:
      '果断敏锐，逻辑缜密，遇事先求证再下结论。她看起来强硬独立，但内心始终为那段被掩埋的往事留着一处柔软。',
    plotPoints: [
      '从一枚香囊的纹样锁定第一个嫌疑人。',
      '在旧宅废墟中发现与自身身世相关的牌位。',
    ],
  },
  {
    id: 'shen-yan-zhi',
    name: '沈砚之',
    actor: '顾九思',
    movieId: 'hua-jian-ling',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20ancient%20mystery%20drama%20character%20portrait%20of%20a%20calm%20young%20male%20official%20in%20cream%20and%20dark%20green%20robes%20holding%20a%20bamboo%20slip%2C%20composed%20inscrutable%20expression%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20soft%20even%20lighting%2C%20high%20detail&width=400&height=400&seq=char-shenyanzhi&orientation=squarish',
    roleTag: '男主角',
    background:
      '大理寺少卿，表面温文尔雅，实则心思深沉。他与林昭昭因案结识，是并肩查案的伙伴，也是真相面前最难以捉摸的那一个。',
    personality:
      '沉稳克制，擅长以退为进。他说话滴水不漏，但对正义的坚持从未动摇，只是在守护的方式上更为迂回。',
    plotPoints: [
      '暗中调取十年前的卷宗，为林昭昭补上关键一环。',
      '在最终对峙中亮明立场，推动旧案尘埃落定。',
    ],
  },
  {
    id: 'chen-mu',
    name: '陈暮',
    actor: '陈暮',
    movieId: 'nan-hai-gui-xu',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20adventure%20film%20character%20portrait%20of%20a%20rugged%20young%20male%20archaeologist%20in%20dark%20green%20field%20jacket%20with%20a%20leather%20satchel%20and%20flashlight%2C%20determined%20curious%20expression%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20soft%20lighting%2C%20high%20detail&width=400&height=400&seq=char-chenmu&orientation=squarish',
    roleTag: '男主角',
    background:
      '民间考古研究者，凭一本残卷认定归墟古城真实存在。他执着于用证据说话，却在深入南海的旅程中，逐渐发现自己的家族与这座古城有着隐秘联系。',
    personality:
      '求知欲强、敢于冒险，遇到谜题就挪不动脚。他理性冷静，但在同伴安全面前，又总会做出「不理性」的选择。',
    plotPoints: [
      '破译残卷中的机关图，找到古城入口。',
      '在最深处发现了刻有家族印记的石碑。',
    ],
  },
  {
    id: 'a-man',
    name: '阿蛮',
    actor: '白芷',
    movieId: 'nan-hai-gui-xu',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20adventure%20film%20character%20portrait%20of%20a%20brave%20young%20fisherwoman%20guide%20in%20beige%20and%20green%20practical%20clothes%20with%20a%20rope%20over%20her%20shoulder%2C%20confident%20friendly%20expression%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20soft%20lighting%2C%20high%20detail&width=400&height=400&seq=char-aman&orientation=squarish',
    roleTag: '女主角',
    background:
      '世代生活在南海边的渔家女，熟悉每一处暗流与礁石。她为考察队担任向导，也带来了关于归墟的古老传说。',
    personality:
      '爽朗直接，行动力极强，是队伍里最可靠的后盾。她敬畏大海，也相信传说背后自有其道理。',
    plotPoints: [
      '凭借经验带领众人避开暗礁与涡流。',
      '在古城崩塌之际果断切断绳索，救下同伴。',
    ],
  },
  {
    id: 'pei-xing',
    name: '裴行',
    actor: '裴行',
    movieId: 'chang-an-ye-xing',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20ancient%20capital%20night%20drama%20character%20portrait%20of%20a%20serious%20young%20patrol%20officer%20in%20dark%20green%20and%20cream%20uniform%20with%20a%20lantern%2C%20alert%20upright%20expression%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20soft%20even%20lighting%2C%20high%20detail&width=400&height=400&seq=char-peixing&orientation=squarish',
    roleTag: '男主角',
    background:
      '长安城巡夜校尉，职责是守住宵禁后的每一段长街。接连发生的离奇案件让他不得不与文书苏莞联手，也逐渐看清了这座城灯火之下的另一面。',
    personality:
      '正直沉稳，按规矩办事，认死理却不迂腐。他不善言辞，却用一次次彻夜的巡行守护着他所相信的秩序。',
    plotPoints: [
      '在雪夜巡逻中首次目击不留痕迹的盗窃现场。',
      '放下对文书的偏见，与苏莞合力还原真相。',
    ],
  },
  {
    id: 'su-wan',
    name: '苏莞',
    actor: '苏莞',
    movieId: 'chang-an-ye-xing',
    avatar: 'https://readdy.ai/api/search-image?query=Refined%20ancient%20capital%20night%20drama%20character%20portrait%20of%20a%20clever%20young%20female%20scribe%20in%20cream%20and%20green%20robes%20holding%20a%20brush%20and%20ledger%2C%20bright%20sharp%20expression%2C%20warm%20cream%20studio%20background%2C%20muted%20dark%20green%20and%20soft%20orange%20palette%2C%20soft%20even%20lighting%2C%20high%20detail&width=400&height=400&seq=char-suwan&orientation=squarish',
    roleTag: '女主角',
    background:
      '掌管城中账册文书的女吏，记性极好，能从最枯燥的记录里找出破绽。她与裴行一静一动，是查案路上互补的搭档。',
    personality:
      '聪慧伶俐，逻辑清晰，嘴上爱跟人抬杠，做事却从不含糊。她相信数据不会说谎，也擅长把碎片拼成完整的图景。',
    plotPoints: [
      '从账册里发现失窃物品之间的隐秘关联。',
      '在城楼之上与裴行并肩，锁定幕后之人。',
    ],
  },
];